import { Injectable } from '@angular/core';
import { Encprecen } from "../coninterfaces/conencprecen";
import { Detprecen } from "../coninterfaces/condetprecen";
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { DatePipe } from '@angular/common';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { MessageService } from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class ConprecenService {
  public url: string;
  public way: string;

  public encprecen: Encprecen[] = []
  public detprecen: Detprecen[][] = []

  constructor(
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private messageService: MessageService,
    private confIniciales: ConfInicialesService,
    private datePipe: DatePipe,
    private init: NuevoComponentService,
    private utilitariosService: UtilitariosService,
  ) {
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
  }
  erpBusquedaCliente(strValor, strValue, strParams) {
    return this.http.post(this.way + '/ventas/facturas/tq8cgrtwkhkurwk', {

      elementos: {
        Valor: strValor,
        Value: strValue,
        Params: strParams
      },

    }, this.confIniciales.httpOptions()).toPromise();
  }
  encontrarArtCntaySer(strArtCodigo, strtipo) {
    return this.http.post<any[]>(this.way + '/compras/ordencompra/75d98bf76adab8000000', {
      elementos: {
        ArtCodigo: strArtCodigo,
        strTIPO: strtipo
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validarcencodigo(cencodigo) {

    return this.http.post<any[]>(this.way + '/ventas/guiaremision/1f5564d56d8ebf0000000000000', {
      elementos: {
        cen_codigo: cencodigo,
        con_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();

  }
  erClinombreProm(strClicodigo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cxc/carteraactiva/3b6cacaf8b2f6e', {
      elementos: {
        CLI_CODIGO: strClicodigo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  busquedaCentroCostos(strCenCodigo) {
    return this.http.post(this.way + '/cont/precen/83bac75d986ca00', {
      elementos: {
        p_cencodigo: strCenCodigo
      },
    }, this.confIniciales.httpOptions());
  }
  busquedaConPreCen() {
    return this.http.post(this.way + '/cont/precen/3317e7aaebb33c00000', {
      elementos: {
       
      },
    }, this.confIniciales.httpOptions());
  }
  insertarEncabezadoprecen(item): Promise<any> {
    return this.http.post<any>(this.way + '/cont/precen/95f8edf54ebb30000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: item.ENCPRECEN_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_ENCPRECEN_FECHAINI: item.ENCPRECEN_FECHAINI,
        p_ENCPRECEN_FECHAFIN: item.ENCPRECEN_FECHAFIN,
        p_CLI_CODIGO: item.CLI_CODIGO,
        p_ENCPRECEN_DESCRIPCION: item.ENCPRECEN_DESCRIPCION,
        p_CEN_CODIGO: item.CEN_CODIGO,
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarDetalleprecen(item): Promise<any> {
    return this.http.post<any>(this.way + '/cont/precen/95f8edf54d7770000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: item.ENCPRECEN_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_DETPRECEN_CODIGO: item.DETPRECEN_CODIGO,
        p_DETPRECEN_LINEA: item.DETPRECEN_LINEA,
        p_DETPRECEN_DESCRIPCION: item.DETPRECEN_DESCRIPCION,
        p_DETPRECEN_CANTIDAD: item.DETPRECEN_CANTIDAD,
        p_DETPRECEN_COSTO: item.DETPRECEN_COSTO,
        p_DETPRECEN_TOTAL: item.DETPRECEN_TOTAL,
        p_DETPRECEN_ORIGENCON: item.DETPRECEN_ORIGENCON,
        p_DETPRECEN_TIPODET: item.DETPRECEN_TIPODET
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultarEncabezadoprecen(numero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/cc5f9eaf54ebb00000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  consultarDetalleprecen(numero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/cc5f9eaf54d7780000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarDetalleFact(item): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/7565695d4d7774000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: item.ENCPRECEN_NUMERO,
        p_COM_CODIGO: item.COM_CODIGO,
        p_DETPRECEN_LINEA: item.DETPRECEN_LINEA
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarregistro(numero): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/7565695d4ebb34000000', {
      elementos: {
        p_ENCPRECEN_NUMERO: numero,
        p_COM_CODIGO: '01'
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  // parseToIntAndScale(n) {
  //   const s = String(n);
  //   if (s.indexOf('e') !== -1) {
  //     return this.parseToIntAndScale(Number(s).toFixed(18).replace(/0+$/, ''));
  //   }
  //   const parts = s.split('.');
  //   const scale = parts[1] ? parts[1].length : 0
  //   const intVal = Number(parts.join(''));
  //   return { intVal, scale }
  // }
  // precideMultiplyAndRound(a, b, decimales) {
  //   const A = this.parseToIntAndScale(a);
  //   const B = this.parseToIntAndScale(b);
  //   const productInt = A.intVal * B.intVal
  //   const productScale = A.scale + B.scale
  //   const value = productInt / Math.pow(10, productScale);
  //   const factor = Math.pow(10, decimales);
  //   return Math.round(value * factor) / factor
  // }
  calcularTotales() {
    let total=0;
    let cantidad
    for (let fila = 1; fila <= this.detprecen[this.init.tabs[this.init.tabindex].indice].length; fila++) {
      let item: Detprecen = this.detprecen[this.init.tabs[this.init.tabindex].indice][fila-1]
      total=0
      total = this.utilitariosService.multiplicar(item.DETPRECEN_CANTIDAD,item.DETPRECEN_COSTO)//this.precideMultiplyAndRound(item.DETPRECEN_CANTIDAD,item.DETPRECEN_COSTO,2);
      item.DETPRECEN_TOTAL= this.utilitariosService.formatear(total,2)//Number(total).toFixed(2)
    }

    for (let fila = 1; fila <= this.detprecen[this.init.tabs[this.init.tabindex].indice].length; fila++) {
      let item: Detprecen = this.detprecen[this.init.tabs[this.init.tabindex].indice][fila-1]
      item.DETPRECEN_CANTIDAD=this.utilitariosService.formatear(item.DETPRECEN_CANTIDAD,2)//Number(item.DETPRECEN_CANTIDAD).toFixed(2)
      item.DETPRECEN_COSTO=this.utilitariosService.formatear(item.DETPRECEN_COSTO,2)//Number(item.DETPRECEN_COSTO).toFixed(2)
      item.DETPRECEN_TOTAL= this.utilitariosService.formatear(item.DETPRECEN_TOTAL,2)//Number(item.DETPRECEN_TOTAL).toFixed(2)
    }
  }
  validacuentasnom(arreglo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/faab26a99e75f8000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validacuentas(arreglo): Promise<any[]> {
    return this.http.post<any[]>(this.way + '/cont/precen/1f5564d533cebf000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
